export var joinClassNames = function joinClassNames() {
  var resClassName = '';

  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  classNames.forEach(function (className) {
    if (className) {
      if (resClassName) {
        resClassName += ' ';
      }

      resClassName += className;
    }
  });
  return resClassName || undefined;
};